import { CompetitionService } from './../providers/competition-service/competition-service';
import {
  ClubMembership,
  ColorOrderPaymentStatus,
  ColorOrderStatus,
  ColorPaymentStatus,
  ColorStayPlayStatus,
  ColorTeeTimeBookingStatus,
  Country,
  CountryData,
  DiscountCompany,
} from './../data/mygolf.data';
import { ClubInfo } from './../data/club-course';
import { HostListener, Injectable } from '@angular/core';
import { JsonService } from './../json-util';
import { ClubFlightService } from './../providers/club-flight-service/club-flight-service';
import * as globals from '../globals';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { PlayerService } from 'src/providers/player-service/player-service';
import { SessionInfo, SessionState } from 'src/data/authentication-info';
import { Observable, filter, map } from 'rxjs';
import { SessionDataService } from 'src/redux/session';
import { sha256 } from 'js-sha256';
import * as CryptoJS from 'crypto-js';
import { CustomSha1 } from 'src/custom/sha1';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

// Define a type for the roles for clarity
type UserRole = string;
type PageName = string;

// Define a separate constant for the complex role-to-page mapping
const pageRoleMap: Record<PageName, UserRole[]> = {
  // Basic Club Roles - Require 'club' userType and at least one role from the list
  booking: ['role_admin', 'role_cashier', 'role_account', 'role_manager'],
  booked_flights: ['role_admin', 'role_cashier', 'role_account', 'role_manager', 'role_operation'],
  caddie_master: ['role_caddy_master', 'role_admin', 'role_operation', 'role_manager', 'role_course_starter'],
  course_starter: ['role_course_starter', 'role_caddy_master', 'role_admin'],
  caddies: ['role_course_starter', 'role_caddy_master', 'role_admin', 'role_cashier', 'role_manager'],
  buggies: ['role_course_starter', 'role_caddy_master', 'role_admin', 'role_cashier', 'role_operation', 'role_manager'],
  booking_stats: ['role_admin', 'role_account', 'role_cashier', 'role_manager'],
  competitions: ['role_caddy_master', 'role_admin', 'role_caddy', 'role_manager', 'role_operation'],
  tournament_scoring: ['role_scorer', 'role_admin'],

  // Caddy Specific Roles
  caddy_reviews: ['role_caddy'], // Note: Original logic was `role.toLowerCase() === 'role_caddy'` inside a filter, which essentially means 'role_caddy'
  caddy_schedules: ['role_caddy', 'role_admin'],
  caddy_assignments: ['role_caddy'],
  caddy: ['role_caddy'],
  scoring: ['role_caddy'],

  // Simple Admin/Club Roles - Require 'club' userType and 'role_admin'
  member: ['role_admin'],
  voucher: ['role_admin'],

  // Partner-Related Roles (Requires specific partner services)
  partner: ['role_partner'], // Simple check, service check handled separately
  agentbooking: ['role_partner'], // Service 'BOOKING_AGENT' checked separately
  nga_membership: ['role_partner'], // Service 'NGA_MEMBERSHIP' checked separately
  discount: ['role_partner'], // Service 'DISCOUNT' checked separately
  insurance: ['role_partner'], // Service 'INSURANCE' checked separately
  nga_only: ['role_partner'], // Service 'NGA_MEMBERSHIP' and isNGA() checked separately

  // High-Level/Global Roles
  admin: ['role_admin', 'role_super_admin'],
  club: ['role_super_admin', 'role_club'],
  socialClub: ['role_club'], // Club type checked separately
  report: ['role_super_admin', 'role_club', 'role_partner', 'role_manager'],
  integration: ['role_super_admin', 'role_admin', 'role_account'], // Club userType checked separately

  // Accounting/Statement Roles
  account: ['role_super_admin', 'role_admin', 'role_account'], // Club userType checked separately
  agent_statement: ['role_super_admin', 'role_admin', 'role_account'], // Note: two separate blocks for 'agent_statement' in original code, using the broader one
  agent_trxn: ['role_super_admin', 'role_admin', 'role_account'], // Club userType checked separately

  // Facility Roles (Handled separately due to complex original logic)
  facilityBooking: ['role_facility_booking', 'facility_booking', 'role_admin', 'role_super_admin'],
  facilityManagement: ['role_facility_management', 'facility_management', 'role_admin', 'role_super_admin'],

  // Stay and Play (S&P) Roles - Requires Club/Partner/SuperAdmin AND a specific sub-role
  stayPlayPackageManage: ['role_snp_manager', 'role_admin'], // Club/Partner/SuperAdmin checked separately
  stayPlayPackageChat: ['role_snp_booking', 'role_admin'], // Club/Partner/SuperAdmin checked separately
  stayPlayPackageRequests: ['role_snp_booking', 'role_admin'], // Club/Partner/SuperAdmin checked separately

  // Tournament & Content Management Roles
  tournaments: ['role_super_admin', 'role_club', 'role_partner', 'role_admin', 'role_organizer'],
  contentManagement: ['role_super_admin', 'role_club', 'role_partner', 'role_admin', 'role_organizer'],
};

@Injectable()
export class mygolfUtils {
  appAttribute: any;
  appAttributes: Array<any> = new Array<any>();
  isClubSpecific: boolean;
  selClubMembership;
  homeClub: ClubInfo;
  clubId: number;
  settingsAttribute: any;

  playerClubMembership: Array<ClubMembership>;

  selectedClub: any;
  isWebParam: boolean;
  enableMGA: boolean = false;
  enableMakePaymentToClub: boolean = false;

  countryList: Array<CountryData>;
  groupClubs: Array<any> = new Array<any>();
  filteredByClub: any;
  clubGroupId: string;

  webPartner: boolean = false;
  webPartnerId: string;

  partnerAttributes: any;

  session$: Observable<SessionInfo>;
  sessionState$: Observable<SessionState>;
  session: any;
  loggedIn$: Observable<boolean>;
  loggedIn: boolean;
  userRoles: Array<any>;
  clubInfo: any;
  loggedInType: string;
  userType: string = null;
  partnerInfo: DiscountCompany;
  sessionState: any;
  constructor(
    private platform: Platform,
    private compService: CompetitionService,
    private playerService: PlayerService,
    private sessionDataService: SessionDataService, // private flightService: ClubFlightService
    private customSha1: CustomSha1,
    private navCtrl: NavController,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private alertCtrl: AlertController
  ) {
    let _param = this.platform.getQueryParam('param');
    if (globals.appType === 'main' && globals.clubId && !_param) this.clubId = globals.clubId;
    this.enableMGA = this.platform.getQueryParam('enableMGA') === 'true';
    this.enableMakePaymentToClub = this.platform.getQueryParam('enableMakePaymentToClub') === 'true';
    this.getCountry();

    this.innerWidth = window.innerWidth;

    this.session$ = this.sessionDataService.getSession();
    this.session$.subscribe((session: SessionInfo) => {
      this.session = session;
    });
    this.sessionState$ = this.sessionDataService.getSessionStatus();
    this.loggedIn$ = this.sessionState$.pipe(
      map(state => {
        return state === SessionState.LoggedIn;
      })
    );

    this.sessionDataService.getSessionStatus().subscribe((data: any) => {
      if (data) this.sessionState = data;
      else this.sessionState = null;

      if (data === 1) this.loggedIn = true;
      else if (data === 3) this.loggedIn = false;
      else if (data === 0) this.loggedIn = true;
      else this.loggedIn = false;
    });

    this.loggedIn$.pipe(filter(Boolean)).subscribe(async data => {
      this.userType = this.session.user.userType;
      this.userRoles = this.session.user && this.session.user.roles ? this.session.user.roles : [];
    });

    this.loggedInType = this.session && this.session.user ? this.session.user.userType : null;
  }
  public numberWithCommas(x: any) {
    // if(!x) return;
    // x = Number(x);
    // x = Number(x.toFixed(2));
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // public getUnique(arr, comp) {

  //     // store the comparison  values in array
  //     const unique = arr.map(e => e[comp])

  //         // store the indexes of the unique objects
  //         .map((e, i, final) => final.indexOf(e) === i && i)

  //         // eliminate the false indexes & return unique objects
  //         .filter((e) => arr[e]).map(e => arr[e]);

  //     return unique;
  // }
  getUnique(arr, comp) {
    const getter = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    const unique = arr
      .map((e, i) => ({ value: getter(e, comp), index: i }))
      .filter((e, i, final) => final.findIndex(t => JSON.stringify(t.value) === JSON.stringify(e.value)) === i)
      .map(e => arr[e.index]);

    return unique;
  }

  public setClubSpecific(clubSpecific: boolean) {
    this.isClubSpecific = clubSpecific;
  }

  public getClubSpecific() {
    return this.isClubSpecific;
  }

  public setAppAttributes(appAttributes) {
    this.appAttributes = appAttributes;
  }

  public getAppAttribute() {
    return this.appAttributes;
  }

  public setClubMembership(selClubMembership) {
    this.selClubMembership = selClubMembership;
  }

  public getClubMembership() {
    return this.selClubMembership;
  }

  public setHomeClub(club) {
    this.homeClub = club;
  }
  public getHomeClub(): ClubInfo {
    return this.homeClub;
  }
  public getClubSpecificHeader(attribute): any {
    // console.debug("#################### start #####################");
    // console.debug("util : attribute", attribute);
    // console.debug("util : selclubmembership", this.selClubMembership);
    // console.debug("util : appAttributes", this.appAttributes);
    // console.debug("util : is web param : ", this.isWebParam);
    // console.debug("util : selected club : ", this.selectedClub);
    // console.debug("util : club id : ", this.clubId);
    // console.debug('####################### end ########################')
    // console.debug("util : ", this.selClubMembership);
    if (!attribute) return;
    if (!this.selClubMembership && !this.isWebParam) return;
    let _clubSpecific = {
      headerLogo: '',
      headerTitle: '',
      enableHeaderLogo: false,
      enableHeaderTitle: false,
      clubId: null,
    };
    if (!this.isWebParam || this.selClubMembership)
      this.appAttributes
        .filter(appAtt => {
          return appAtt.page === 'playerHome';
        })
        .map(appAtt => {
          appAtt.clubSpecificThemes
            .filter(cc => {
              return this.selClubMembership.club.clubId === cc.clubId;
            })
            .map(cc => {
              _clubSpecific = cc;
            });
        });
    // else if(this.isWebParam && this.selectedClub) {
    //     this.appAttributes.filter((appAtt)=>{
    //         return appAtt.page === 'playerHome'
    //     }).map((appAtt)=>{
    //         appAtt.clubSpecificThemes.filter((cc)=>{
    //             return this.selectedClub.id === cc.clubId;
    //         }).map((cc)=>{
    //             _clubSpecific = cc;
    //         });
    //     })
    // }
    else if (this.isWebParam) {
      if (!this.selectedClub && this.clubId && this.appAttributes) {
        // console.debug("util selected club no : ", this.selectedClub, _clubSpecific)
        // (!_clubSpecific.clubId) &&
        //// console.debug("util inside : ", this.selectedClub, this.clubId, _clubSpecific, this.appAttributes);
        this.appAttributes
          .filter(appAtt => {
            return appAtt.page === 'playerHome';
          })
          .map(appAtt => {
            // console.debug("util inside : ", appAtt.clubSpecificThemes)
            appAtt.clubSpecificThemes
              .filter(cc => {
                return this.clubId === cc.clubId;
              })
              .map(cc => {
                _clubSpecific = cc;
              });
          });
      } else if (this.selectedClub) {
        // console.debug("util selected club yes : ", this.selectedClub, _clubSpecific)
        // !_clubSpecific.clubId) &&
        if (this.selectedClub.clubLogo) _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
        else if (!this.selectedClub.clubLogo && this.selectedClub.clubThumbnail)
          _clubSpecific['headerLogo'] = globals.MygolfServer + '/' + this.selectedClub.clubLogo;
        else if (!this.selectedClub.clubLogo && !this.selectedClub.clubThumbnail && this.selectedClub.clubImage)
          _clubSpecific.headerLogo = this.selectedClub.clubImage;
        _clubSpecific['headerTitle'] = this.selectedClub.name ? this.selectedClub.name : this.selectedClub.clubName;
        _clubSpecific['enableHeaderLogo'] = true;
        _clubSpecific['enableHeaderTitle'] = false;
      }
    }
    // setTimeout(() =>{

    switch (attribute) {
      case 'header-logo':
        // JsonService.deriveFullUrl(_clubSpecific, "headerLogo");
        let _headerLogo = '';
        if (this.isWebParam) _headerLogo = _clubSpecific['headerLogo'];
        else _headerLogo = globals.MygolfServer + '/' + _clubSpecific['headerLogo'];

        return _headerLogo;
      case 'header-title':
        return _clubSpecific['headerTitle'];
      case 'enableHeaderLogo':
        return _clubSpecific['enableHeaderLogo'];
      case 'enableHeaderTitle':
        return _clubSpecific['enableHeaderTitle'];
      case 'showWalletBalance':
        return _clubSpecific['showWalletBalance'];
      case 'showCreditBalance':
        let _showCreditBal: boolean = true;
        if (_clubSpecific['showCreditBalance'] !== undefined) _showCreditBal = _clubSpecific['showCreditBalance'];
        else if (_clubSpecific['showWalletBalance'] === undefined && _clubSpecific['showCreditBalance'] === undefined)
          _showCreditBal = true;
        else if (!_clubSpecific['showWalletBalance'] && !_clubSpecific['showCreditBalance']) _showCreditBal = true;
        else _showCreditBal = _clubSpecific['showCreditBalance'];
        return _showCreditBal; // _clubSpecific['showCreditBalance'];
    }
    // }, 1000)
  }

  public getMembershipType(attribute?: string) {
    if (!this.selClubMembership) return 'Membership No.';
    let _membershipType = {};
    this.appAttributes
      .filter(appAtt => {
        return appAtt.page === 'playerHome';
      })
      .map(appAtt => {
        appAtt.membershipTypes
          .filter(mtype => {
            return mtype.id === this.selClubMembership.membershipType;
          })
          .map(mtype => {
            _membershipType['id'] = mtype.id;
            if (mtype.id === 'F' || mtype.id === 'T') _membershipType['name'] = 'Membership No.';
            else _membershipType['name'] = mtype.name;
          });
      });
    if (attribute === 'id') return _membershipType['id'];
    else return _membershipType['name'];
  }

  public getClubLogo(attribute) {
    if (!this.appAttributes) return;
    if (!this.clubId) return;
    let _clubLogo;
    let _clubBanner;

    this.appAttributes
      .filter(appAtt => {
        return appAtt.page === 'playerHome';
      })
      .map(appAtt => {
        appAtt.clubSpecificThemes
          .filter(theme => {
            return theme.clubId === this.clubId;
          })
          .map(theme => {
            // JsonService.deriveFulImageURL(theme, "clubLogo")
            // JsonService.deriveFulImageURL(theme, "bannerLogo")
            _clubLogo = theme.clubLogo;
            _clubBanner = theme.bannerLogo; //clubBanner;
          });
      });

    switch (attribute) {
      case 'logo':
        return _clubLogo;
      case 'banner':
        return _clubBanner;
    }
  }

  public getSettingsAttribute() {
    if (!this.appAttributes) return;

    let _settingsAttribute;
    this.appAttributes
      .filter(appAtt => {
        return appAtt.page === 'appSettings';
      })
      .map(appAtt => {
        _settingsAttribute = appAtt;
        this.settingsAttribute = appAtt;
      });

    return _settingsAttribute;
  }

  public getSpecificAppAttributePage(page: string) {
    if (!page) return;
    if (!this.appAttributes) return;
    let _appAttribute = null;
    this.appAttributes
      .filter(appAtt => {
        return appAtt.page === page;
      })
      .map(appAtt => {
        _appAttribute = appAtt;
      });
    if (!_appAttribute) return;
    else return _appAttribute;
  }

  setPlayerClubMembership(playerClubMembership: Array<ClubMembership>) {
    this.playerClubMembership = playerClubMembership;
  }

  public getPlayerClubMembership() {
    return this.playerClubMembership;
  }

  setClubId(clubId: number) {
    // window.resizeTo(50, 50);

    // window.resizeBy(1300,450)// = 800;
    this.clubId = clubId;
    if (this.isClubSpecific) this.setCompClubId();
  }

  async setCompClubId() {
    let searchCriteriaComp = this.compService.getSearch();
    searchCriteriaComp.clubId = this.clubId; // this.selClubMembership.club.clubId;
    this.compService.setSearch(searchCriteriaComp);
  }

  public getClubId() {
    return this.clubId;
  }

  setSelectedClub(club: any) {
    this.selectedClub = club;
  }

  getSelectedClub() {
    return this.selectedClub;
  }

  setClubParam(param: boolean) {
    this.isWebParam = param;
  }

  getClubParam() {
    return this.isWebParam;
  }

  getColorBookingStatus(bookingStatus) {
    if (!bookingStatus) return;
    let _color = 'Black';
    for (let status in ColorTeeTimeBookingStatus) {
      if (status === bookingStatus.toUpperCase()) _color = ColorTeeTimeBookingStatus[status];
    }
    return _color;
  }

  getColorOrderStatus(orderStatus) {
    if (!orderStatus) return;
    let _color = 'Black';
    for (let status in ColorOrderStatus) {
      if (status === orderStatus.toUpperCase()) _color = ColorOrderStatus[status];
    }
    return _color;
  }

  getColorOrderPaymentStatus(paymentStatus) {
    if (!paymentStatus) return;
    let _color = 'Black';
    for (let status in ColorOrderPaymentStatus) {
      if (status === paymentStatus.toUpperCase()) _color = ColorOrderPaymentStatus[status];
    }
    return _color;
  }
  getColorPaymentStatus(paymentStatus) {
    if (!paymentStatus) return;
    let _color = 'Black';
    for (let status in ColorPaymentStatus) {
      if (status === paymentStatus.toUpperCase()) _color = ColorPaymentStatus[status];
    }
    return _color;
  }

  getColorStayPlayRequestStatus(requestStatus) {
    // console.debug('requestStatus [0]', requestStatus);
    if (!requestStatus) return;
    let _color = 'Black';
    for (let status in ColorStayPlayStatus) {
      // console.debug('requestStatus [1]', status, ' - ', requestStatus, ColorStayPlayStatus[status]);
      if (status === requestStatus.toUpperCase()) _color = ColorStayPlayStatus[status];
    }
    return _color;
  }
  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach(item => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  getMGALogo() {
    let _mgaLogo = globals.MygolfServer + '/document/logo/MGA_logo.png';
    return _mgaLogo;
  }

  isMGAEnable() {
    let _appAttribute = this.getSpecificAppAttributePage('externalNHS');
    if (_appAttribute && _appAttribute.enableMGA !== undefined) this.enableMGA = _appAttribute.enableMGA;
    return this.enableMGA;
  }

  isMakePaymentToClub() {
    let _appAttribute = this.getSpecificAppAttributePage('accountOptions');
    if (_appAttribute && _appAttribute.enableMakePaymentToClub !== undefined)
      this.enableMakePaymentToClub = _appAttribute.enableMakePaymentToClub;

    return this.enableMakePaymentToClub;
  }

  setUserType(type: string) {
    this.userType = type;
  }

  getUserType() {
    // console.debug('get user type : ', this.userType);
    return this.userType;
  }

  setPartnerInfo(partner) {
    this.partnerInfo = partner;
  }

  getPartnerInfo() {
    return this.partnerInfo;
  }

  isBookingOverrideEnable() {
    let _bookingOverrideEnable: boolean = false;
    const idEnable = this.platform.getQueryParam('bookingOverrideEnable');
    _bookingOverrideEnable = idEnable === 'true';
    return _bookingOverrideEnable;
  }

  persistClubTheme: any = null;
  setPersistClubTheme(type?: string) {
    if (type === 'communal') this.persistClubTheme = type;
    else if (type) this.persistClubTheme = type;
    else this.persistClubTheme = null;
  }

  isPersistClubTheme() {
    return this.persistClubTheme;
  }

  preferredCountry: Country;
  setPreferredCountry(countryId: string) {
    this.preferredCountry = null;
    this.countryList
      .filter((c: Country) => {
        return c.id === countryId;
      })
      .map((c: CountryData) => {
        this.preferredCountry = c;
      });
  }

  getPreferredCountry() {
    return this.preferredCountry;
  }

  clearPreferredCountry() {
    this.preferredCountry = null;
  }

  getCountry() {
    this.playerService.getCountryList().subscribe((data: Array<Country>) => {
      this.countryList = data;
    });
  }
  setClubGroupInfo(groupId: string, clubs: Array<number>, initiate: boolean = false) {
    this.clubGroupId = groupId;
    this.groupClubs = clubs;
    if (initiate) {
      this.filteredByClub = this.groupClubs[0];
    }
  }

  setGroupFilterClub(clubId: number) {
    this.filteredByClub = clubId;
  }

  getClubGroupInfo(attribute?: string) {
    if (!attribute) return;
    switch (attribute) {
      case 'clubGroupId':
        return this.clubGroupId;
      case 'groupClubs':
        return this.groupClubs;
    }
  }

  isMobileLayout() {
    return this.platform.width() < 768;
  }

  encodeKey(key: string, type?: string) {
    if (type) {
      return key;
    } else return btoa(key);
  }

  decodeKey(key: string, type?: string) {
    if (type) {
      return key;
    } else return atob(key);
  }

  getWebParams() {
    let _webPartnerId;
    if (this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk')) && this.decodeKey('d2ViUGFydG5lcklk') === 'webPartnerId') {
      _webPartnerId = this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk'));
      if (_webPartnerId) {
        this.webPartnerId = _webPartnerId;
        this.webPartner = true;
      }
    }

    console.debug(
      'web partner id : ',
      _webPartnerId,
      this.platform.getQueryParam('d2ViUGFydG5lcklk'),
      this.decodeKey(this.platform.getQueryParam('d2ViUGFydG5lcklk'))
    );
  }

  public setPartnerAttributes(partnerAttributes) {
    this.partnerAttributes = partnerAttributes;
  }

  public getPartnerAttribute() {
    return this.partnerAttributes;
  }
  getGroupFilterClub() {
    return this.filteredByClub;
  }

  clubAgentsList: Array<any> = [];
  agentClubsList: Array<any> = [];
  getAgentsForClub() {
    return this.clubAgentsList;
  }

  getClubsForAgent() {
    return this.agentClubsList;
  }

  setClubsForAgent(clubs: Array<any>) {
    this.agentClubsList = clubs;
  }

  setAgentsForClub(agents: Array<any>) {
    this.clubAgentsList = agents;
  }

  mergeObjects(object1, object2, key: string) {
    if (!object1) return;
    if (!object2) return;
    const merged = {};
    console.debug('merging 2 objects with key : ', key, object1, object2);

    // Merge object1 into merged
    object1.forEach(item => {
      merged[key] = { ...merged[key], ...item };
    });

    // Merge object2 into merged
    object2.forEach(item => {
      merged[key] = { ...merged[key], ...item };
    });

    // Convert the merged object into an array if needed
    const mergedArray = Object.keys(merged).map(key => merged[key]);
    return mergedArray;
  }

  clubSlotCourseSelected: any;

  setSlotCourseSelected(course?: any) {
    this.clubSlotCourseSelected = course;
  }

  getSlotCourseSelected() {
    return this.clubSlotCourseSelected;
  }

  courseSlotPageInfo: any;

  setSlotCoursePageInfo(info: any) {
    this.courseSlotPageInfo = info;
  }

  getSlotCoursePageInfo() {
    return this.courseSlotPageInfo;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }
  innerWidth: any;
  getInnerWidth() {
    return this.innerWidth;
  }

  // getRange(n: number, start?: number): number[] {
  //     return Array(n).fill(0).map((_, index) => index + start);
  //     // return Array(n).fill(0).map((_, index) => index);
  // }
  getRange(n: number, start: number = 0): number[] {
    return Array(n)
      .fill(0)
      .map((_, index) => index + start);
    // return Array(n).fill(0).map((_, index) => index);
  }

  removeKeysFromObject(obj: Record<string, boolean>, keysToRemove: string[]): void {
    keysToRemove.forEach(key => {
      if (key in obj) {
        delete obj[key];
      }
    });
  }

  appendKeysToObject(obj: Record<string, boolean>, keysToAdd: string[], defaultValue: boolean = false): void {
    keysToAdd.forEach(key => {
      if (!(key in obj)) {
        obj[key] = defaultValue;
      }
    });
  }

  getFacilityIcon(outletTypeName: string) {
    let _facilityIcon = 'assets/image/homeImg/facility/';
    switch (outletTypeName) {
      case 'Driving Range':
        _facilityIcon += 'icon_driving_range.svg';
        break;
      case 'Restaurant':
        _facilityIcon += 'Restaurant.png';
        break;
      case 'Pro Shop':
        _facilityIcon += 'ProShop.png';
        break;
      case 'Swimming Pool':
        _facilityIcon += 'icon_swimming_pool.png';
        break;
      case 'Golf':
        _facilityIcon += 'Golf.png';
        break;
      case 'Tennis':
        _facilityIcon += 'icon_tennis.png';
        break;
      case 'Table Tennis':
        _facilityIcon += 'icon_table-tennis.png';
        break;
      case 'Badminton':
        _facilityIcon += 'badminton.png';
        break;
      case 'Squash':
        _facilityIcon += 'icon_squash.png';
        break;
      case 'Sauna':
        _facilityIcon += 'sauna.png';
        break;
      case 'Hotel and Villa':
        _facilityIcon += 'HotelAndVilla.png';
        break;
      case 'Banquet Hall':
        _facilityIcon += 'BanquetHall.png';
        break;
      case 'Flower Shop':
        _facilityIcon += 'Flower Shop.png';
        break;
      case 'Slot Machine':
        _facilityIcon += 'SlotMachine.png';
        break;
      case 'Cigar Lounge':
        _facilityIcon += 'CigarLounge.png';
        break;
      case 'Simulator':
        _facilityIcon += 'Simulator.png';
        break;
      case 'Games Room':
        _facilityIcon += 'icon_billiard.png';
        break;
      case 'Pickle Ball':
        _facilityIcon += 'icon_pickleball.png';
        break;
      case 'Paddle Ball':
        _facilityIcon += 'icon_paddle_ball.png';
        break;
      case 'Other':
        _facilityIcon += 'other.png';
        break;
      case 'Pickle Ball':
        _facilityIcon += 'Pickleball.png';
        break;
      case 'Paddle Ball':
        _facilityIcon += 'Paddle.png';
        break;
    }
    return _facilityIcon;
  }

  getClubType() {
    if (!this.clubInfo) return;
    let _clubType = 'golfClub';
    if (this.clubInfo?.virtualClub) _clubType = 'socialClub';
    return _clubType;
  }
  loggedInAdmin: boolean;
  getUserRoles(page?: string) {
    // if(!this.userRoles || this.userRoles.length === 0 ||  !this.loggedInAdmin) return false;
    // console.debug(
    //   'get user roles for ',
    //   page,
    //   ' - ',
    //   this.loggedInType,
    //   this.userRoles,
    //   this.getClubType(),
    //   this.userType,
    //   this.clubInfo
    // );
    // if (page === 'messaging')
    //   console.debug(
    //     'get user roles for ',
    //     page,
    //     ' - ',
    //     this.loggedInType,
    //     this.userRoles,
    //     this.userHasRole(this.userRoles, 'role_super_admin'),
    //     this.userHasRole(this.userRoles, 'role_club') && this.userHasRole(this.userRoles, 'role_admin'),
    //     this.clubInfo?.clubTag?.toLowerCase().includes('wagc')
    //   );
    if (!this.userType) return;
    if (this.loggedInType === 'Britesoft') return true;
    if (this.getClubType() === 'socialClub') {
      if (page === 'contentManagement') return true;
      if (this.getClubType() === 'socialClub' && page !== 'socialClub') return false;
    }
    let _userRole;
    let _rolesAllowed;
    let _isAdmin: boolean = false;
    _isAdmin =
      page === 'caddy' || page === 'caddy_reviews' || page === 'caddy_schedules' || page === 'caddy_assignments' || page === 'scoring'
        ? false
        : this.loggedInAdmin;

    if (this.userRoles && this.userRoles.length > 0) {
      _userRole = this.userRoles.filter((role: any) => {
        if (!role) return false;
        // || !role.authority
        // console.log("roles : ", role)
        // return this.userHasRole(this.userRoles,type.toLowerCase());
        // if(page === 'facilityBooking' &&
        // ((this.userHasRole(this.userRoles, 'role_facility_management') && this.userHasRole(this.userRoles, 'role_club') && this.userRoles?.length === 3) ||
        // this.userHasRole(this.userRoles, 'role_facility_booking') && this.userHasRole(this.userRoles, 'role_club') && this.userRoles?.length === 2)) {
        //   _rolesAllowed = true
        //   return _rolesAllowed
        // }
        if (
          (this.userHasRole(this.userRoles, 'role_facility_management') &&
            this.userHasRole(this.userRoles, 'role_club') &&
            (this.userRoles?.length === 2 || this.userRoles?.length === 3)) ||
          (this.userHasRole(this.userRoles, 'role_facility_booking') &&
            this.userHasRole(this.userRoles, 'role_club') &&
            this.userRoles?.length === 2)
        ) {
          if (page === 'facilityManagement' && this.userHasRole(this.userRoles, 'role_facility_management')) {
            _rolesAllowed = true;
          } else if (page === 'facilityBooking' && this.userHasRole(this.userRoles, 'role_facility_booking')) {
            _rolesAllowed = true;
          } else if (page === 'booking_stats' && this.userHasRole(this.userRoles, 'role_facility_management')) {
            _rolesAllowed = true;
          } else if (page === 'report' && this.userHasRole(this.userRoles, 'role_facility_management')) {
            _rolesAllowed = true;
          } else {
            _rolesAllowed = false;
          }
          return _rolesAllowed;
        } else {
          if (page === 'booking') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_cashier') ||
                this.userHasRole(this.userRoles, 'role_account') ||
                this.userHasRole(this.userRoles, 'role_manager'));
            return _rolesAllowed;
          } else if (page === 'booked_flights') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_cashier') ||
                this.userHasRole(this.userRoles, 'role_account') ||
                this.userHasRole(this.userRoles, 'role_manager') ||
                this.userHasRole(this.userRoles, 'role_operation'));
            return _rolesAllowed;
          } else if (page === 'caddie_master') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_caddy_master') ||
                this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_operation') ||
                this.userHasRole(this.userRoles, 'role_manager') ||
                this.userHasRole(this.userRoles, 'role_course_starter'));
            return _rolesAllowed;
          } else if (page === 'course_starter') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_course_starter') ||
                this.userHasRole(this.userRoles, 'role_caddy_master') ||
                this.userHasRole(this.userRoles, 'role_admin'));
            return _rolesAllowed;
          } else if (page === 'caddies') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_course_starter') ||
                this.userHasRole(this.userRoles, 'role_caddy_master') ||
                this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_cashier') ||
                this.userHasRole(this.userRoles, 'role_manager'));
            return _rolesAllowed;
          } else if (page === 'buggies') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_course_starter') ||
                this.userHasRole(this.userRoles, 'role_caddy_master') ||
                this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_cashier') ||
                this.userHasRole(this.userRoles, 'role_operation') ||
                this.userHasRole(this.userRoles, 'role_manager'));
            return _rolesAllowed;
          } else if (page === 'booking_stats') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_account') ||
                this.userHasRole(this.userRoles, 'role_cashier') ||
                this.userHasRole(this.userRoles, 'role_manager'));
            return _rolesAllowed;
          } else if (page === 'competitions') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_caddy_master') ||
                this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_caddy') ||
                this.userHasRole(this.userRoles, 'role_manager') ||
                this.userHasRole(this.userRoles, 'role_operation'));
            return _rolesAllowed;
          } else if (page === 'tournament_scoring') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (this.userHasRole(this.userRoles, 'role_scorer') || this.userHasRole(this.userRoles, 'role_admin'));
            return _rolesAllowed;
          } else if (page === 'caddy_reviews') {
            _rolesAllowed = role.toLowerCase() === 'role_caddy';
            // this.userType.toLowerCase().includes('club') &&
            // || this.userHasRole(this.userRoles,'manager')
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'caddy_schedules') {
            _rolesAllowed =
              this.userType.toLowerCase().includes('club') &&
              (role.toLowerCase() === 'role_caddy' ||
                this.userHasRole(this.userRoles, 'role_caddy') ||
                this.userHasRole(this.userRoles, 'role_admin'));
            // if(this.userHasRole(this.userRoles,'role_partner'))
            //     _rolesAllowed = false;
            // this.userType.toLowerCase().includes('club') &&
            // || this.userHasRole(this.userRoles,'manager')
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'caddy_assignments') {
            _rolesAllowed = role.toLowerCase() === 'role_caddy';
            // this.userType.toLowerCase().includes('club') &&
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'caddy') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_caddy');
            // this.userType.toLowerCase().includes('club') &&
            // || this.userHasRole(this.userRoles,'manager')
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'member') {
            _rolesAllowed = this.userType.toLowerCase().includes('club') && this.userHasRole(this.userRoles, 'role_admin');
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'scoring') {
            _rolesAllowed = this.userType.toLowerCase().includes('club') && role.toLowerCase() === 'role_caddy';
            // || this.userHasRole(this.userRoles,'admin')
            return _rolesAllowed;
          } else if (page === 'voucher') {
            _rolesAllowed = this.userType.toLowerCase().includes('club') && this.userHasRole(this.userRoles, 'role_admin');
            return _rolesAllowed;
          } else if (page === 'partner') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner');
            // console.debug("page - ", page, " | rolesAllowed : ", _rolesAllowed)
            return _rolesAllowed;
          } else if (page === 'report') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              // this.userHasRole(this.userRoles, 'role_club') ||
              this.userHasRole(this.userRoles, 'role_admin')||
              this.userHasRole(this.userRoles, 'role_partner') ||
              this.userHasRole(this.userRoles, 'role_manager')||
              this.userHasRole(this.userRoles, 'role_reporting')||
              this.userHasRole(this.userRoles, 'role_account');
            // && (this.userHasRole(this.userRoles,'role_admin') || this.userHasRole(this.userRoles,'role_cashier') || this.userHasRole(this.userRoles,'role_account')))
            // this.userHasRole(this.userRoles,['role_club','role_admin','role_cashier','role_account'])
            // console.debug("page - ", page, " | rolesAllowed : ", _rolesAllowed, " - " ,role)

            return _rolesAllowed;
          } else if (page === 'integration') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_account')));
            return _rolesAllowed;
          } else if (page === 'agentbooking') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner') && this.getPartnerServices('BOOKING_AGENT');
            return _rolesAllowed;
          } else if (page === 'nga_membership') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner') && this.getPartnerServices('NGA_MEMBERSHIP');
            // console.debug(
            //   'get user role ',
            //   page,
            //   this.userRoles,
            //   this.userHasRole(this.userRoles, 'role_partner'),
            //   this.getPartnerServices('NGA_MEMBERSHIP'),
            //   _rolesAllowed
            // );
            return _rolesAllowed;
          } else if (page === 'discount') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner') && this.getPartnerServices('DISCOUNT');
            return _rolesAllowed;
          } else if (page === 'insurance') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner') && this.getPartnerServices('INSURANCE');
            return _rolesAllowed;
          } else if (page === 'nga_only') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_partner') && this.isNGA() && this.getPartnerServices('NGA_MEMBERSHIP');
            return _rolesAllowed;
          } else if (page === 'admin') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_super_admin');
            return _rolesAllowed;
          } else if (page === 'account') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_account')));
            return _rolesAllowed;
          } else if (page === 'agent_statement') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_account')));
            return _rolesAllowed;
          } else if (page === 'agent_statement') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') && this.userHasRole(this.userRoles, 'role_admin'));
            return _rolesAllowed;
          } else if (page === 'agent_list') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_account')));
            return _rolesAllowed;
          }
          else if (page === 'agent_trxn') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.userType.toLowerCase().includes('club') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_account')));
            return _rolesAllowed;
          } else if (page === 'club') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_super_admin') || this.userHasRole(this.userRoles, 'role_club');
            return _rolesAllowed;
          } else if (page === 'socialClub') {
            _rolesAllowed = this.userHasRole(this.userRoles, 'role_club') && this.getClubType() === 'socialClub';
            return _rolesAllowed;
          } else if (page === null && this.userHasRole(this.userRoles, 'role_super_admin')) {
            _rolesAllowed = true;
            return _rolesAllowed;
          } else if (page === 'facilityBooking') {
            // console.debug("page - facility booking ", page, this.getClubType(), this.userType, role)
            _rolesAllowed =
              (this.userType.toLowerCase() === 'club' && this.userHasRole(this.userRoles, 'facility_booking')) ||
              this.userHasRole(this.userRoles, 'role_facility_booking') ||
              this.userHasRole(this.userRoles, 'role_admin') ||
              this.userHasRole(this.userRoles, 'role_super_admin');
            return _rolesAllowed;
          } else if (page === 'facilityManagement') {
            // console.debug("page - facility management ", page, this.getClubType(), this.userType, role)
            _rolesAllowed =
              this.userType.toLowerCase() === 'club' &&
              (this.userHasRole(this.userRoles, 'facility_management') ||
                this.userHasRole(this.userRoles, 'role_facility_management') ||
                this.userHasRole(this.userRoles, 'role_admin') ||
                this.userHasRole(this.userRoles, 'role_super_admin'));
            return _rolesAllowed;
          } else if (page === 'stayPlayPackageManage') {
            console.debug('get user role ', page, this.userHasRole(this.userRoles, 'role_snp_manager'));
            // console.debug(
            //   'get user role [1]',
            //   page,
            //   this.userHasRole(this.userRoles, 'role_super_admin') ||
            //     this.userHasRole(this.userRoles, 'role_club') ||
            //     this.userHasRole(this.userRoles, 'role_partner')
            // );
            _rolesAllowed =
              (this.userHasRole(this.userRoles, 'role_super_admin') ||
                this.userHasRole(this.userRoles, 'role_club') ||
                this.userHasRole(this.userRoles, 'role_partner')) &&
              (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_snp_manager'));
            return _rolesAllowed;
          } else if (page === 'stayPlayPackageChat') {
            _rolesAllowed =
              (this.userHasRole(this.userRoles, 'role_super_admin') ||
                this.userHasRole(this.userRoles, 'role_club') ||
                this.userHasRole(this.userRoles, 'role_partner')) &&
              (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_snp_booking'));
            return _rolesAllowed;
          } else if (page === 'stayPlayPackageRequests') {
            console.debug('get user role ', page, this.userHasRole(this.userRoles, 'role_snp_booking'));
            _rolesAllowed =
              (this.userHasRole(this.userRoles, 'role_super_admin') ||
                this.userHasRole(this.userRoles, 'role_club') ||
                this.userHasRole(this.userRoles, 'role_partner')) &&
              (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_snp_booking'));
            return _rolesAllowed;
          } else if (page === 'tournaments') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              this.userHasRole(this.userRoles, 'role_club') ||
              (this.userHasRole(this.userRoles, 'role_partner') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_organizer')));

            // console.debug('get user roles : ', page, _rolesAllowed);
            return _rolesAllowed;
          } else if (page === 'contentManagement') {
            _rolesAllowed =
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              this.userHasRole(this.userRoles, 'role_account') ||
              (this.userHasRole(this.userRoles, 'role_partner') &&
                (this.userHasRole(this.userRoles, 'role_admin') || this.userHasRole(this.userRoles, 'role_organizer')));
            return _rolesAllowed;
          } else if (page === 'messaging') {
            if (
              this.userHasRole(this.userRoles, 'role_super_admin') ||
              (this.clubInfo?.clubTag?.toLowerCase().includes('wagc') &&
                this.userHasRole(this.userRoles, 'role_club') &&
                this.userHasRole(this.userRoles, 'role_admin'))
            )
              _rolesAllowed = true;
            else _rolesAllowed = false;

            return _rolesAllowed;
          } else return false;
        }
      });
    }
    if ((_userRole && _userRole.length > 0) || this.loggedInType === 'Britesoft') {
      // console.debug(
      //   'get user roles for ',
      //   page,
      //   ' - ',
      //   _userRole,
      //   this.loggedInType,
      //   this.userType
      // );
      return true;
    } else return false;
  }

  userHasRole(userRoles: Array<string>, role: string) {
    return userRoles.some(ur => {
      return ur?.toLowerCase() === role?.toLowerCase();
    });
  }

  isNGA() {
    if (!this.partnerInfo) return;
    let _allow = this.partnerInfo.nationalGolfAssociation;
    return _allow;
  }

  getPartnerServices(services?: string) {
    if (!this.partnerInfo) return;
    let _allow;
    _allow = this.partnerInfo.partnerServices.find(s => s.toLowerCase() === services.toLowerCase());
    return _allow;
  }

  /**
   * @param type sha256, hmacsha-512, sha1
   * @param key
   * @param value
   */
  generateHashSignature(type: string, value: string, key?: string) {
    let _type = 'sha256';
    let hexHash = '';
    if (!type) _type = 'sha256';
    else _type = type?.toLowerCase();
    switch (_type) {
      case 'sha256':
        return sha256(value);
      case 'hmac-sha512':
        const hashA = CryptoJS.HmacSHA512(value, key);
        hexHash = hashA.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'hmacsha-512':
        const hashB = CryptoJS.HmacSHA512(value, key);
        hexHash = hashB.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'hmacsha512':
        const hashC = CryptoJS.HmacSHA512(value, key);
        hexHash = hashC.toString(CryptoJS.enc.Hex);
        return hexHash;
      case 'sha1':
        return this.customSha1.iPay88Signature(value);
    }
  }

  _btoa(str: string): string {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  }

  goToHome() {
    this.location.replaceState('tabs/app-home');
    this.navCtrl.navigateRoot('tabs/app-home');
  }

  clearAllValues() {
    this.userRoles = null;
    this.userType = null;
    this.loggedInType = null;
    this.loggedInAdmin = null;
  }

  clearWebParams(deleteParams: Array<string>) {
    //! ActivatedRoute by angular - not working
    // const queryParams = { ...this.route.snapshot.queryParams };
    // console.debug('pending clearing web params : ', deleteParams, queryParams);
    // deleteParams?.forEach((p: string) => {
    //   delete queryParams[p];
    // });
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: queryParams,
    //   replaceUrl: true,
    // });

    const url = new URL(window.location.href);
    console.debug('pending clearing web params : ', deleteParams, url);
    deleteParams?.forEach((p: string) => {
      console.debug('pending clearing web params [1]: ', p, url.searchParams);
      url.searchParams.delete(p);
    });
    window.history.replaceState({}, '', url.toString());
  }

  capitalizeFirstLetter(str: string, onlyFirstLetter?: boolean): string {
    if (onlyFirstLetter) str = str?.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  isEInvoiceEnabled() {
    // console.debug('is einvoice enabled [0] : ', this.appAttributes);
    if (!this.appAttributes) return false;
    if (this.appAttributes?.length === 0) return false;
    const mainAppAttributes = this.appAttributes?.find(appAtt => appAtt?.page === 'mainApp');
    // console.debug('is einvoice enabled : ', mainAppAttributes);
    if (mainAppAttributes?.enableEInvoice) return true;
    else if (mainAppAttributes?.enableEInvoice === undefined) return false;
    else return false;
  }

  setClubInfo(clubInfo) {
    this.clubInfo = clubInfo;
  }

  clearClubInfo() {
    this.clubInfo = null;
  }

  // Helper function to check if the user has any of the required roles
  // Assuming this is a utility method on the class/service
  private userHasAnyRole(roles: UserRole[]): boolean {
    if (!this.userRoles || this.userRoles.length === 0) return false;
    return roles.some(role => this.userHasRole(this.userRoles, role));
  }

  // Main refactored function
  newGetUserRoles(page?: PageName): boolean {
    // 1. Logging (kept for debugging as it was in the original)
    // if (page === 'messaging')
    //   console.debug(
    //     'get user roles for ',
    //     page,
    //     ' - ',
    //     this.loggedInType,
    //     this.userRoles,
    //     this.clubInfo,
    //     this.userHasRole(this.userRoles, 'role_super_admin') ||
    //       (this.clubInfo?.clubTag?.toLowerCase().includes('wagc') &&
    //         this.userHasRole(this.userRoles, 'role_club') &&
    //         this.userHasRole(this.userRoles, 'role_admin'))
    //     // ... (rest of logging)
    //   );

    // 2. Immediate Exits (Super Admin/System User checks)
    if (!this.userType) return false; // Return false instead of 'undefined/void' for boolean methods
    if (this.loggedInType === 'Britesoft') return true;
    if (page === null && this.userHasRole(this.userRoles, 'role_super_admin')) return true;

    // 3. Social Club Specific Logic
    if (this.getClubType() === 'socialClub') {
      if (page === 'contentManagement') return true;
      if (page === 'stayPlayPackageRequests') return true;
      if (page === 'stayPlayPackageManage') return true;
      if (page === 'socialClub') {
        return this.userHasRole(this.userRoles, 'role_club');
      }
      // Original logic: If it's a social club and the page is NOT 'socialClub', return false
      // return false;
    }

    // 4. Facility Management/Booking Complex Logic
    // This part had complicated checks involving role count (userRoles?.length === 2 || userRoles?.length === 3),
    // which is bad practice but preserved in function
    const isFacilityClubUser =
      this.userHasRole(this.userRoles, 'role_club') && (this.userRoles?.length === 2 || this.userRoles?.length === 3);

    if (isFacilityClubUser && this.userHasRole(this.userRoles, 'role_facility_management')) {
      if (['facilityManagement', 'booking_stats', 'report'].includes(page!)) return true;
    }

    if (this.userHasRole(this.userRoles, 'role_club') && this.userRoles?.length === 2) {
      if (this.userHasRole(this.userRoles, 'role_facility_booking') && page === 'facilityBooking') return true;
    }

    // 5. Messaging Special Case (WAGC)
    if (page === 'messaging') {
      return (
        this.userHasRole(this.userRoles, 'role_super_admin') ||
        (this.clubInfo?.clubTag?.toLowerCase().includes('wagc') &&
          this.userHasRole(this.userRoles, 'role_club') &&
          this.userHasRole(this.userRoles, 'role_admin'))
      );
    }

    // 6. Role Mapping (General Page/Role Checks)
    const requiredRoles = pageRoleMap[page!];

    if (requiredRoles) {
      const hasRequiredRole = this.userHasAnyRole(requiredRoles);

      if (hasRequiredRole) {
        // Further checks based on 'userType' or 'partner service' for specific groups
        const isClubUser = this.userType.toLowerCase().includes('club');
        const isPartnerRole = this.userHasRole(this.userRoles, 'role_partner');
        const isClubOrPartnerOrSuperAdmin = isClubUser || isPartnerRole || this.userHasRole(this.userRoles, 'role_super_admin');

        switch (page) {
          // Roles that MUST be Club UserType (most golf club-related pages)
          case 'booking':
          case 'booked_flights':
          case 'caddie_master':
          case 'course_starter':
          case 'caddies':
          case 'buggies':
          case 'booking_stats':
          case 'competitions':
          case 'tournament_scoring':
          case 'member':
          case 'voucher':
          case 'scoring':
          case 'caddy_schedules': // This one is an OR in original, but role_admin is in the map, and we check club type here
          case 'integration':
          case 'account':
          case 'agent_statement':
          case 'agent_trxn':
          case 'facilityBooking':
          case 'facilityManagement':
            if (isClubUser) return true;
            // Fall through to other checks if not a club user
            break;

          // Partner Roles with service checks
          case 'agentbooking':
            return isPartnerRole && this.getPartnerServices('BOOKING_AGENT');
          case 'nga_membership':
            return isPartnerRole && this.getPartnerServices('NGA_MEMBERSHIP');
          case 'discount':
            return isPartnerRole && this.getPartnerServices('DISCOUNT');
          case 'insurance':
            return isPartnerRole && this.getPartnerServices('INSURANCE');
          case 'nga_only':
            return isPartnerRole && this.isNGA() && this.getPartnerServices('NGA_MEMBERSHIP');

          // S&P and Tournament/Content Management
          case 'stayPlayPackageManage':
          case 'stayPlayPackageChat':
          case 'stayPlayPackageRequests':
          case 'tournaments':
          case 'contentManagement':
            if (isClubOrPartnerOrSuperAdmin) return true;
            break;

          // Simple check where only having ANY of the roles in the map is enough (e.g., caddy pages, partner)
          case 'caddy_reviews':
          case 'caddy_assignments':
          case 'caddy':
          case 'partner':
          case 'report':
          case 'admin':
          case 'club':
            return true;

          default:
          // If the page is in the map but failed any specific internal checks (like Club UserType)
          // we fall through to the final return false.
        }
      }
    }

    // 7. Final Default
    return false;
  }



      currentUserAuthorities: Array<string>;
      setAuthorities(authorities: Array<string>) {
        this.currentUserAuthorities = authorities;
      }

      getAuthorities() {
        return this.currentUserAuthorities;
      }

      checkAuthority(authority: string) {
        if(!authority) return;
        let _hasAuthority = [];
        let _auth = authority.toLowerCase();
        if(this.currentUserAuthorities && this.currentUserAuthorities.length > 0) {
            _hasAuthority = this.currentUserAuthorities.filter((auth: string)=>{
                return auth.toLowerCase().includes(_auth)
            })
        }
        return _hasAuthority && _hasAuthority.length > 0
      }

      async displayAuthorityMessage(authority: string, severityCode: string = 'I', customMsg?: string) {
        // title: string, message: string, severityCode: string = 'I'
        let _msg = '';
        let _title = 'Unauthorized access';
        if(authority.toLowerCase() === 'assign_caddies') {
            _msg = "You don't have privilege to assign any caddies. Please contact the club administrator.";
        } else if(authority.toLowerCase() === 'assign_buggies') {
            _msg = "You don't have privilege to assign any buggies. Please contact the club administrator.";
        } else if(authority.toLowerCase() === 'assign_preferred_caddies') {
            _msg = "You don't have privilege to select / assign any preferred caddies. Please contact the club administrator.";
        } else if(authority.toLowerCase() === 'checkin_without_pmt') {
            _msg = "You don't have privilege to check-in players without full payment for the flight. Please contact the club administrator.";
        }
        if(customMsg && customMsg.length > 0) {
            _msg = customMsg;
        }
        return new Promise(async (resolve, reject) => {
            let _cssClass = '';
            if(severityCode === 'E') _cssClass = 'booking-error';
            let alert = await this.alertCtrl.create({
                header: _title,
                message: _msg,
                cssClass: _cssClass,
                buttons: [{
                        text: 'Dismiss',
                        role: 'cancel',
                        handler: () => {
                            resolve(false);
                        }
                    },
                    {
                        text: 'Ok',
                        handler: () => {
                            resolve(true)
                        }
                    },
                ]
            });
            alert.present();
        })
    }
}
